import { render, staticRenderFns } from "./CommonDeliveryStatusSelect.vue?vue&type=template&id=612bc5c2&lang=pug&"
import script from "./CommonDeliveryStatusSelect.vue?vue&type=script&lang=ts&"
export * from "./CommonDeliveryStatusSelect.vue?vue&type=script&lang=ts&"
import style0 from "./CommonDeliveryStatusSelect.vue?vue&type=style&index=0&id=612bc5c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports